import { motion } from "framer-motion";
import { HERO_IMAGE, HERO_PERSON } from "../data";

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end pt-28 overflow-hidden">
    <div className="absolute inset-0">
      <img src={HERO_IMAGE} alt="Modern luxury California home" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
    </div>

    <motion.img
      src={HERO_PERSON}
      alt="Melissa O'Donnell, Realtor"
      data-testid="hero-person"
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 1, delay: 0.4 }}
      className="hidden lg:block absolute bottom-0 -right-20 xl:-right-10 z-[6] h-[62%] w-auto object-contain drop-shadow-2xl pointer-events-none select-none"
    />

    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-12 md:pb-16 w-full">
      <div className="max-w-2xl">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="eyebrow text-white mb-6"
      >
        Redlands · Palm Springs · Temecula
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="font-heading font-light text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] max-w-4xl"
      >
        Modern Real Estate.<br />Unmatched Expertise.
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.25 }}
        className="text-white/85 text-lg sm:text-xl font-light max-w-xl mt-8 leading-relaxed"
      >
        A technologically advanced Southern California real estate group delivering modern,
        data-driven service that simply can't be matched.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.4 }}
        className="inline-flex flex-col gap-4 mt-10"
      >
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="#quiz"
            data-testid="hero-cta-primary"
            className="flex-1 flex items-center justify-center bg-gold text-white text-base sm:text-lg font-bold px-9 py-4 hover:bg-gold-hover transition-colors text-center tracking-wide whitespace-nowrap"
          >
            Start Your Journey
          </a>
          <a
            href="#featured"
            data-testid="hero-cta-secondary"
            className="flex-1 flex items-center justify-center border-2 border-white text-white text-base sm:text-lg font-bold px-9 py-4 hover:bg-white hover:text-[#0a0a0a] transition-colors text-center tracking-wide whitespace-nowrap"
          >
            View Sold Homes
          </a>
        </div>
        <a
          href="#home-value"
          data-testid="hero-cta-valuation"
          className="flex items-center justify-center gap-2 w-full bg-white/10 backdrop-blur-sm border border-gold/70 text-white text-base sm:text-lg font-medium px-6 py-4 hover:bg-gold hover:border-gold transition-colors text-center tracking-wide"
        >
          What's my home worth? Get a free estimate →
        </a>
      </motion.div>
      </div>
    </div>
  </section>
);
